(function () {
  'use strict';
  var R = window.nvR || { root: '/', cart: '/cart', add: '/cart/add', change: '/cart/change' };
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function store(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }

  /* ---------- compte à rebours (relance automatique) ---------- */
  function tick() {
    $$('[data-timer]').forEach(function (el) {
      var mins = parseFloat(el.getAttribute('data-min')) || 5;
      var loop = el.getAttribute('data-loop') !== 'false';
      var key = 'nv-t-' + (el.getAttribute('data-key') || 'cart');
      var now = Date.now();
      var end = parseInt(store(key) || '0', 10);
      if (!end || end <= now) {
        if (!end || loop) { end = now + mins * 60000; store(key, String(end)); }
      }
      var left = Math.max(0, end - now);
      var c = el.querySelector('[data-timer-clock]');
      if (c) c.textContent = pad(Math.floor(left / 60000)) + ':' + pad(Math.floor(left / 1000) % 60);
    });
  }

  /* ---------- panier tiroir ---------- */
  var cd = $('[data-cd]');
  function openCart() {
    if (!cd) { location.href = R.cart; return; }
    cd.classList.add('is-open');
    cd.setAttribute('aria-hidden', 'false');
    document.body.classList.add('nv-lock');
    tick();
    var x = cd.querySelector('[data-cd-close].nv-ico');
    if (x) setTimeout(function () { x.focus({ preventScroll: true }); }, 60);
  }
  function closeCart() {
    if (!cd) return;
    cd.classList.remove('is-open');
    cd.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('nv-lock');
  }
  function setCount(n) {
    $$('[data-cart-count]').forEach(function (e) { e.textContent = n; e.hidden = !n; });
  }
  function refresh() {
    return fetch(R.root + '?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var html = j && j['cart-drawer'];
        if (!html || !cd) return;
        var d = document.createElement('div');
        d.innerHTML = html;
        var np = d.querySelector('.nv-cd__p'), op = cd.querySelector('.nv-cd__p');
        if (np && op) {
          op.innerHTML = np.innerHTML;
          setCount(parseInt(np.getAttribute('data-count') || '0', 10));
        }
        promo();
        tick();
      });
  }
  function change(line, qty, btn) {
    var page = btn.closest('[data-cartpage]');
    var box = page || cd;
    if (box) box.classList.add('is-busy');
    fetch(R.change + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: Math.max(0, qty) })
    }).then(function () {
      if (page) { location.reload(); return; }
      return refresh();
    }).catch(function () { location.reload(); })
      .then(function () { if (box) box.classList.remove('is-busy'); });
  }

  /* ---------- code promo ---------- */
  function promo() {
    var code = '';
    try { code = localStorage.getItem('nv-promo') || ''; } catch (e) {}
    $$('[data-checkout]').forEach(function (a) { a.href = '/checkout' + (code ? '?discount=' + encodeURIComponent(code) : ''); });
    $$('[data-promo-in]').forEach(function (i) { if (code && !i.value) i.value = code; });
    $$('[data-promo-msg]').forEach(function (m) {
      m.hidden = !code;
      if (code) m.textContent = 'Code « ' + code + ' » appliqué au moment du paiement.';
    });
  }

  /* ---------- fiche produit ---------- */
  function variants(form) {
    if (form._v) return form._v;
    var s = form.querySelector('[data-nv-variants]');
    try { form._v = s ? JSON.parse(s.textContent) : []; } catch (e) { form._v = []; }
    return form._v;
  }
  function findV(list, opts) {
    for (var i = 0; i < list.length; i++) {
      var ok = true;
      for (var j = 0; j < opts.length; j++) if (list[i].options[j] !== opts[j]) { ok = false; break; }
      if (ok) return list[i];
    }
    return null;
  }
  function unitOpts(u) { return $$('select[data-opt]', u).map(function (s) { return s.value; }); }
  function check(form) {
    var list = variants(form), bad = false;
    var off = form.querySelector('[data-offer].is-on') || form.querySelector('[data-offer]');
    $$('[data-unit]', form).forEach(function (u) { u.classList.remove('is-out'); });
    if (off) $$('[data-unit]', off).forEach(function (u) {
      var v = findV(list, unitOpts(u));
      if (!v || !v.available) { u.classList.add('is-out'); bad = true; }
    });
    var err = form.querySelector('[data-nv-err]');
    if (err) {
      err.hidden = !bad;
      if (bad) err.textContent = 'Ce coloris n’est plus disponible dans cette taille. Choisissez-en une autre.';
    }
    return !bad;
  }
  function pickOffer(card) {
    var form = card.closest('[data-nv-form]');
    $$('[data-offer]', form).forEach(function (o) { o.classList.toggle('is-on', o === card); });
    var r = card.querySelector('.nv-of__in');
    if (r) r.checked = true;
    check(form);
  }
  function addToCart(form) {
    if (!check(form)) return;
    var list = variants(form);
    var off = form.querySelector('[data-offer].is-on') || form.querySelector('[data-offer]');
    var title = off ? off.getAttribute('data-title') : '';
    var units = off ? $$('[data-unit]', off) : [];
    var qty = {}, order = [];
    if (units.length) {
      units.forEach(function (u) {
        var v = findV(list, unitOpts(u));
        if (!qty[v.id]) { qty[v.id] = 0; order.push(v.id); }
        qty[v.id]++;
      });
    } else {
      var id = form.getAttribute('data-default-id');
      order.push(id);
      qty[id] = parseInt(off ? off.getAttribute('data-qty') : '1', 10) || 1;
    }
    var items = order.map(function (id) {
      var it = { id: parseInt(id, 10), quantity: qty[id] };
      if (title) it.properties = { 'Offre': title };
      return it;
    });
    var btn = form.querySelector('[data-nv-add]'), err = form.querySelector('[data-nv-err]');
    if (btn) btn.classList.add('is-busy');
    fetch(R.add + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Erreur'); });
    }).then(refresh).then(openCart).catch(function (e) {
      if (err) { err.textContent = e.message || 'Impossible d’ajouter au panier.'; err.hidden = false; }
    }).then(function () { if (btn) btn.classList.remove('is-busy'); });
  }
  function galleryTo(root, i) {
    var t = root && root.querySelector('[data-gal-track]');
    if (t) t.scrollTo({ left: t.clientWidth * i, behavior: reduce ? 'auto' : 'smooth' });
  }
  function initGallery(root) {
    var t = root.querySelector('[data-gal-track]'), th = $$('[data-gal-thumb]', root);
    if (!t || !th.length) return;
    var to;
    t.addEventListener('scroll', function () {
      clearTimeout(to);
      to = setTimeout(function () {
        var i = Math.round(t.scrollLeft / t.clientWidth);
        th.forEach(function (b, j) { b.classList.toggle('is-on', i === j); });
      }, 80);
    }, { passive: true });
  }

  /* ---------- guide des tailles ---------- */
  function sizeCalc(root) {
    var rows = (root.getAttribute('data-table') || '').split(',').map(function (r) {
      var p = r.trim().split(':');
      return { n: (p[0] || '').trim(), b: parseFloat(p[1]) || 999, w: parseFloat(p[2]) || 999 };
    }).filter(function (r) { return r.n; });
    var out = root.querySelector('[data-sg-res]');
    if (!rows.length || !out) return;
    var h = parseFloat(root.querySelector('[data-sg-h]').value) || 0;
    var w = parseFloat(root.querySelector('[data-sg-w]').value) || 0;
    var b = parseFloat(root.querySelector('[data-sg-b]').value) || 0;
    out.hidden = false;
    if (!w && !b) { out.innerHTML = '<p style="margin:0">Indiquez au moins votre poids ou votre tour de taille.</p>'; return; }
    function idx(val, k) { for (var i = 0; i < rows.length; i++) if (val <= rows[i][k]) return i; return rows.length - 1; }
    var iw = w ? idx(w, 'w') : 0, ib = b ? idx(b, 'b') : 0;
    var i = b ? Math.max(ib, w ? iw - 1 : 0) : iw;
    if (h >= 177 && i < rows.length - 1 && i <= iw) i++;
    i = Math.max(0, Math.min(rows.length - 1, i));
    var s = rows[i].n, lo = i > 0 ? rows[i - 1].n : '';
    out.innerHTML = '<div>Taille recommandée : <b>' + s + '</b></div><p>' +
      (lo ? 'Confortable dès ' + s + '. Vous pouvez aussi prendre ' + lo + ' pour un maintien plus ferme.' : 'Le ' + s + ' vous offrira le meilleur maintien.') + '</p>';
    var form = $('[data-nv-form]');
    if (!form) return;
    $$('select[data-opt]', form).forEach(function (sel) {
      if (!/taille|size/i.test(sel.getAttribute('data-name') || '')) return;
      for (var k = 0; k < sel.options.length; k++) if (sel.options[k].value === s) { sel.value = s; break; }
    });
    check(form);
  }

  /* ---------- dates de livraison ---------- */
  function shipDates() {
    $$('[data-ship-d]').forEach(function (el) {
      var d = new Date();
      d.setDate(d.getDate() + (parseInt(el.getAttribute('data-ship-d'), 10) || 0));
      var t = d.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });
      el.textContent = t.charAt(0).toUpperCase() + t.slice(1);
    });
  }

  /* ---------- avis défilants ---------- */
  function railStep(r) {
    var c = r.firstElementChild;
    return c ? c.getBoundingClientRect().width + (parseFloat(getComputedStyle(r).columnGap) || 16) : r.clientWidth;
  }
  function railMove(r, dir) {
    var end = r.scrollLeft + r.clientWidth >= r.scrollWidth - 4;
    if (dir > 0 && end) r.scrollTo({ left: 0, behavior: 'smooth' });
    else r.scrollBy({ left: dir * railStep(r), behavior: 'smooth' });
  }
  function initRail(r) {
    var s = parseInt(r.getAttribute('data-auto') || '0', 10);
    if (!s || reduce) return;
    var paused = false, seen = false;
    ['pointerdown', 'mouseenter', 'focusin'].forEach(function (e) { r.addEventListener(e, function () { paused = true; }); });
    r.addEventListener('mouseleave', function () { paused = false; });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { seen = en[0].isIntersecting; }).observe(r);
    else seen = true;
    setInterval(function () { if (!paused && seen && !document.hidden) railMove(r, 1); }, s * 1000);
  }

  /* ---------- frise « comment ça marche » ---------- */
  var progs = [];
  function progUpdate() {
    var vh = window.innerHeight;
    progs.forEach(function (el) {
      var r = el.getBoundingClientRect();
      var p = (vh * 0.6 - r.top) / r.height;
      p = Math.max(0, Math.min(1, p));
      el.style.setProperty('--p', p.toFixed(3));
      $$('[data-step]', el).forEach(function (s) {
        var sr = s.getBoundingClientRect();
        s.classList.toggle('is-on', sr.top + 30 < vh * 0.6);
      });
    });
  }
  var progTick = false;
  function progInit() {
    progs = $$('[data-prog]');
    if (!progs.length) return;
    if (reduce) { progs.forEach(function (el) { el.style.setProperty('--p', '1'); $$('[data-step]', el).forEach(function (s) { s.classList.add('is-on'); }); }); return; }
    progUpdate();
  }
  window.addEventListener('scroll', function () {
    if (!progs.length || progTick) return;
    progTick = true;
    requestAnimationFrame(function () { progTick = false; progUpdate(); });
  }, { passive: true });
  window.addEventListener('resize', function () { if (progs.length) progUpdate(); });

  /* ---------- clics ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target, el;
    if ((el = t.closest('[data-cart-open]'))) { e.preventDefault(); openCart(); return; }
    if ((el = t.closest('[data-cd-close]'))) { closeCart(); return; }
    if ((el = t.closest('[data-qty-set]'))) { change(parseInt(el.getAttribute('data-line'), 10), parseInt(el.getAttribute('data-qty-set'), 10), el); return; }
    if ((el = t.closest('[data-promo-apply]'))) {
      var inp = el.parentNode.querySelector('[data-promo-in]');
      var code = inp ? inp.value.trim().toUpperCase() : '';
      try { if (code) localStorage.setItem('nv-promo', code); else localStorage.removeItem('nv-promo'); } catch (x) {}
      promo();
      return;
    }
    if ((el = t.closest('[data-menu]'))) {
      var n = $('[data-mnav]');
      if (n) { n.hidden = !n.hidden; el.setAttribute('aria-expanded', n.hidden ? 'false' : 'true'); }
      return;
    }
    if ((el = t.closest('[data-gal-nav]'))) {
      var tr = el.closest('[data-gal]').querySelector('[data-gal-track]');
      tr.scrollBy({ left: parseInt(el.getAttribute('data-gal-nav'), 10) * tr.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      return;
    }
    if ((el = t.closest('[data-gal-thumb]'))) { galleryTo(el.closest('[data-gal]'), parseInt(el.getAttribute('data-gal-thumb'), 10)); return; }
    if ((el = t.closest('[data-rail-nav]'))) {
      var r = el.closest('section').querySelector('[data-rail]');
      if (r) railMove(r, parseInt(el.getAttribute('data-rail-nav'), 10));
      return;
    }
    if ((el = t.closest('[data-sg-calc]'))) { sizeCalc(el.closest('[data-sg]')); return; }
    if ((el = t.closest('[data-sg-howto]'))) {
      var how = el.parentNode.querySelector('[data-sg-how]');
      if (how) { how.hidden = !how.hidden; el.setAttribute('aria-expanded', how.hidden ? 'false' : 'true'); }
      return;
    }
    if ((el = t.closest('[data-offer]')) && !t.closest('select')) { if (!el.classList.contains('is-on')) pickOffer(el); }
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('.nv-of__in')) { pickOffer(t.closest('[data-offer]')); return; }
    if (t.matches('select[data-opt]')) {
      var form = t.closest('[data-nv-form]');
      check(form);
      var v = findV(variants(form), unitOpts(t.closest('[data-unit]')));
      if (v && v.featured_image && v.featured_image.position) galleryTo($('[data-gal]'), v.featured_image.position - 1);
    }
  });

  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-nv-form]');
    if (f) { e.preventDefault(); addToCart(f); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && cd && cd.classList.contains('is-open')) closeCart();
    if ((e.key === 'Enter' || e.key === ' ') && e.target.matches('[data-sg-calc]')) { e.preventDefault(); sizeCalc(e.target.closest('[data-sg]')); }
  });

  function safe(f){ try { f(); } catch (e) { if (window.console) console.warn('aurlya', e); } }
  function boot() {
    safe(tick);
    safe(promo);
    safe(shipDates);
    safe(function () { $$('[data-gal]').forEach(initGallery); });
    safe(function () { $$('[data-rail]').forEach(initRail); });
    safe(function () { $$('[data-nv-form]').forEach(check); });
    safe(progInit);
  }
  setInterval(tick, 1000);
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
